import EnlargedImg from "public/cyber-security/edrmdrxdr/enlargedInfographic.png";
import InfographicImg from "public/cyber-security/edrmdrxdr/Infographic.png";

export const COLLAB_CONSTANTS = {
  title: "OneMind : A Comprehensive Approach to Cybersecurity",
  description:
    "To deliver next-gen threat protection, OneMind partners with industry leader Sophos, integrating their advanced security technologies into our EDR, MDR, and XDR services.",
  list: [
    {
      label: "XDR Integration",
      subLabel: "AI-powered XDR platform enables OneMind to:",
      points: [
        "Gain comprehensive visibility across endpoints, cloud, email, and networks.",
        "Detect active adversaries through behavioral and threat intelligence.",
        "Seamlessly correlate data from multiple sources for faster response to complex, multi-stage attacks.",
      ],
    },
    {
      label: "Round-the-Clock MDR",
      subLabel:
        "24/7 Managed Detection & Response service extends OneMind’s capabilities with:",
      points: [
        "Continuous threat monitoring and analysis by cybersecurity experts.",
        "Full-scale incident response, ensuring quick neutralization of threats.",
        "Reduced noise and simplified operations, even across complex environments.",
      ],
    },
    {
      label: "Stronger Together",
      subLabel:
        "By integrating  proven technologies into our AI-native platform, OneMind provides:",
      points: [
        "Faster detection across the attack surface.",
        "Smarter, automated response.",
        "A dramatically reduced risk surface—without added complexity.",
        "Together, OneMind and Sophos deliver enterprise-grade protection for a rapidly evolving threat landscape.",
      ],
    },
  ],
  image: InfographicImg,
  magnifiedImage: EnlargedImg,
  maxW: "600px",
};
